import { RatesResponse } from "../_models/rates";

function getSurchargeList(
  rates: RatesResponse | null
): any[] | null {
  const list =
    rates?.data?.productDetailsList?.[0]?.surcharge?.surchargeOption;
  return list?.length ? list : null;
}

function normalizeSurchargeLabel(value: string): string {
  return value.trim().toLowerCase().replace("vallet service", "valet service");
}

/**
 * Finds a surcharge by label: exact enLabel match first, then substring.
 * Standalone "Commercial" does not match longer labels (e.g. Light Duty).
 */
function findSurchargeOptionIndex(list: any[], option: string): number {
  const needle = normalizeSurchargeLabel(option);
  for (let i = 0; i < list.length; i++) {
    const label = normalizeSurchargeLabel(list[i].label.enLabel);
    if (label === needle) {
      return i;
    }
  }
  const commercialOnly = needle === "commercial";
  for (let i = 0; i < list.length; i++) {
    const label = normalizeSurchargeLabel(list[i].label.enLabel);
    if (commercialOnly) {
      continue;
    }
    if (label.includes(needle)) {
      return i;
    }
  }
  return -1;
}

export function getSurchargeAmountFromRates(
  rates: RatesResponse,
  option: string
): number {
  const list = getSurchargeList(rates);
  if (!list) {
    return 0;
  }
  const idx = findSurchargeOptionIndex(list, option);
  return idx >= 0 ? Number(list[idx].surchargeAmount) : 0;
}

export function findSurchargeOptionFromRates(
  rates: RatesResponse,
  option: string
): any {
  const list = getSurchargeList(rates);
  if (!list) {
    return undefined;
  }
  const idx = findSurchargeOptionIndex(list, option);
  return idx >= 0 ? list[idx] : undefined;
}
